import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button, Box, Copy, Input, Loader } from '@elparking/components'
import {
    TwoFaModal,
} from '@elparking/login'
import { injectIntl, FormattedMessage } from 'react-intl'
import messages from './messages'
import SocialButtons from 'commons/js/components/SocialButtons'
import { BlinkingInput } from './ui/Login'
import UrlTo from 'commons/js/util/UrlTo'
class Form extends Component {
    static propTypes = {
        errors: PropTypes.any,
        onSubmit: PropTypes.func,
        intl: PropTypes.object,
        loading: PropTypes.bool,
        disabled: PropTypes.bool,
        refreshReCaptcha: PropTypes.func,
        email: PropTypes.string,
        inputComponent: PropTypes.elementType,
        trackEvent: PropTypes.func,
        renderReCaptcha: PropTypes.func,
        loginEventName: PropTypes.string,
        request: PropTypes.func.isRequired,
        start2faAuth: PropTypes.number.isRequired,
        params: PropTypes.object,
        onLoginSuccess: PropTypes.func,
        onReceiveError: PropTypes.func,
    }

    static defaultProps = {
        renderReCaptcha: () => <div />,
        onSubmit: () => { },
        errors: {},
        trackEvent: () => { },
        loading: false,
        disabled: true,
        email: undefined,
        inputComponent: Input,
    }

    state = {
        email: this.props.email,
        password: '',
        error: null,
    }

    onChangeEmail = this.onChangeEmail.bind(this)
    onChangePassword = this.onChangePassword.bind(this)
    onSubmit = this.onSubmit.bind(this)
    setError = this.setError.bind(this)

    onChangeEmail (email) {
        this.setState({ email })
    }

    onChangePassword (password) {
        this.setState({ password })
    }

    onSubmit (event) {
        const { trackEvent, onSubmit, loginEventName } = this.props
        const { email, password } = this.state

        event.preventDefault()

        trackEvent(loginEventName)
        onSubmit({ email, password })
    }

    setError (error) {
        this.setState({ error })
    }

    formatErrors (error) {
        const { intl } = this.props
        if (error) {
            if (error.message) {
                return {
                    'network': intl.formatMessage(error.message),
                }
            }
            let errors = {}
            for (const item in error) {
                errors[error[item].field] = error[item].message
            }
            return errors
        }
        return {}
    }

    renderError (error) {
        if (!error) {
            return null
        }
        return <Copy padding='4px 0' color='red' size='xxSmall' fontWeight='regular'>{error}</Copy>
    }

    componentDidUpdate (prevProps) {
        const { email } = this.props

        if (prevProps.email !== email) {
            this.onChangeEmail(email)
            this.passwordField && this.passwordField.focus()
        }
    }

    renderEmailField () {
        const {
            intl,
            email: showBlinking,
            inputComponent: InputComponent,
        } = this.props

        if (showBlinking) {
            return (
                <InputComponent
                  key={this.state.email}
                  fieldInputContainerComponent={BlinkingInput}
                  onChange={this.onChangeEmail}
                  dataTest='login-email'
                  label={intl.formatMessage(messages.usermail)}
                  value={this.state.email}
                />
            )
        }

        return (
            <InputComponent
              onChange={this.onChangeEmail}
              dataTest='login-email'
              label={intl.formatMessage(messages.usermail)}
              value={this.state.email}
            />
        )
    }

    render () {
        const {
            errors: unformatedErrors,
            loading,
            disabled,
            refreshReCaptcha,
            intl,
            renderReCaptcha,
            inputComponent: InputComponent,
            request,
            start2faAuth,
            params,
            onLoginSuccess,
            onReceiveError,
        } = this.props
        const {
            password,
        } = this.state

        const errors = this.formatErrors(unformatedErrors)
        return (
            <form onSubmit={this.onSubmit}>
                <Box pb='8px'>
                    {this.renderEmailField()}
                </Box>
                <Copy padding='0 0 8px 0'>
                    {this.renderError(errors.email)}
                </Copy>
                <Box pb='15px'>
                    <InputComponent
                      ref={(input) => { this.passwordField = input }}
                      type='password'
                      dataTest='login-password'
                      onChange={this.onChangePassword}
                      label={intl.formatMessage(messages.userpassword)}
                      value={password}
                      disable={loading || disabled}
                    />
                    {this.renderError(errors.password)}
                    {this.renderError(errors.network)}
                </Box>
                <Box pb='24px'>
                    <Button type='submit' className='js-btn-login' width='100%' disable={loading || disabled} height='40px' fontWeight='medium' fontSize='medium' onClick={this.onSubmit} dataTest='login-booking-process-button'>
                        {loading && <Loader />} <FormattedMessage defaultMessage='Inicia sesión' />
                    </Button>
                </Box>
                <Box>
                    {renderReCaptcha()}
                </Box>
                <SocialButtons
                  hrefFacebook={UrlTo.get('user/account/request-password-reset-for-social-network', { socialNetwork: 'facebook' })}
                  hrefGoogle={UrlTo.get('user/account/request-password-reset-for-social-network', { socialNetwork: 'google' })}
                />
                <TwoFaModal
                  request={request}
                  start2faAuth={start2faAuth}
                  params={params}
                  onSuccess={onLoginSuccess}
                  onConnectionError={onReceiveError}
                  userEmail={params && params.email}
                  isCaptchaLoading={disabled}
                  refreshReCaptcha={refreshReCaptcha}
                />
            </form>
        )
    }
}

export default injectIntl(Form)
